import { EField as EContactField } from "../forms/addContact/schema.addContact.types";
import { areContactFieldsValid } from "../redux/form/form.utils";
import { ERegistrationFailedReasonCode, ERegistrationFailedReason, } from "../types/registration.types";
import { getAllRequiredCompanyFields, getAllRequiredContactFields, } from "./forms.utils";
export var mapRegistrationFailedReasonCodeToReason = function (code) {
    switch (code) {
        case ERegistrationFailedReasonCode.GeneralError:
            return ERegistrationFailedReason.GeneralError;
        case ERegistrationFailedReasonCode.InvalidFormat:
            return ERegistrationFailedReason.InvalidFormat;
        case ERegistrationFailedReasonCode.AddressNotFound:
            return ERegistrationFailedReason.AddressNotFound;
        case ERegistrationFailedReasonCode.DuplicatedRequest:
            return ERegistrationFailedReason.DuplicatedRequest;
        default:
            return null;
    }
};
/**
 * The contact fields MyRent needs from a private person on a registration.
 * Shared by the manual registration wizard and the signing wizard's
 * auto-registration step, so both collect exactly the same data.
 */
export var getRegistrationContactFieldsSchema = function (contact) {
    return getAllRequiredContactFields({
        contact: contact,
        requiredFields: [
            EContactField.Address,
            EContactField.DateOfBirth,
            EContactField.Nationality,
            EContactField.PlaceOfBirth,
        ],
        appendIdentityNumberToRequiredFields: true,
    });
};
/**
 * The same, for a party that is a company - as the manual registration wizard
 * asks it. 4ea718c1c1 emptied this list on purpose: it made ContactSelect stop
 * skipping companies outright, and a company contact cannot be created without
 * its own required fields, so the wizard asks for nothing on top. Keep it that
 * way; the stricter bar below is the auto-registration step's, not this one's.
 */
export var getRegistrationCompanyFieldsSchema = function (contact) {
    return getAllRequiredCompanyFields({
        contact: contact,
        requiredFields: [],
    });
};
/**
 * The company fields the auto-registration step needs on top. MyRent's XSD
 * requires both the company number and the address, so a company that is asked
 * for nothing produces a payload MyRent rejects - but that is only true of the
 * parties this step sends itself. The manual wizard keeps its own bar above.
 */
export var getAutoRegistrationCompanyFieldsSchema = function (contact) {
    return getAllRequiredCompanyFields({
        contact: contact,
        requiredFields: [EContactField.VATNumber, EContactField.Address],
    });
};
/**
 * The parties whose data MyRent would reject. The signing wizard's
 * auto-registration step pre-selects its parties, and ContactSelect's inline
 * warning only blocks a contact the user selects themselves, so the step needs
 * this to gate on.
 */
export var getIncompleteRegistrationParties = function (contacts) {
    return contacts.filter(function (contact) {
        return !areContactFieldsValid({
            contact: contact,
            requiredContactFieldsSchema: getRegistrationContactFieldsSchema(contact),
            requiredCompanyFieldsSchema: getAutoRegistrationCompanyFieldsSchema(contact),
        });
    });
};
